'use client';
import { useEffect, useState } from 'react';

import { breakpointValues } from '../tokens/sizes';

// tailwind.config is not shipped in the published package, so the breakpoints
// come from the sizes token; sizes.spec.ts guards it against tailwind-preset.cjs.
const sizesMap = Object.fromEntries(
  Object.entries(breakpointValues).map(([key, value]) => [key, `${value}px`])
) as Record<keyof typeof breakpointValues, string>;

export const useHasHover = () => {
  try {
    return matchMedia('(hover: hover)').matches;
  } catch {
    // Assume that if browser too old to support matchMedia it's likely not a touch device
    return true;
  }
};

// https://github.com/shadcn-ui/ui/blob/main/apps/www/hooks/use-media-query.tsx
export const useMediaQuery = (size: keyof typeof sizesMap) => {
  const [value, setValue] = useState(false);

  useEffect(() => {
    try {
      const onChange = (event: MediaQueryListEvent) => {
        setValue(event.matches);
      };
      const result = matchMedia(`(max-width: ${sizesMap[size]})`);
      result?.addEventListener?.('change', onChange);
      setValue(result.matches);

      return () => {
        result?.removeEventListener?.('change', onChange);
      };
    } catch {
      setValue(false);

      return () => {
        // empty
      };
    }
  }, [size]);

  return value;
};
